import { useState } from 'react';
import { MdAnchor, MdWarehouse, MdSupportAgent, MdRule, MdDirectionsBoat, MdAttachMoney } from 'react-icons/md';
import { PageHeader, erpPageTabsClass, erpPageTabClasses } from '@euroasiann/shared/ui';
import { PortList } from './components/PortList';
import { TerminalList } from './components/TerminalList';
import { AgentList } from './components/AgentList';
import { WarehouseList } from './components/WarehouseList';
import { RulesChargesUI } from './components/RulesChargesUI';

type Tab = 'ports' | 'terminals' | 'agents' | 'warehouses' | 'rules' | 'charges';

export function PortManagementPage() {
  const [activeTab, setActiveTab] = useState<Tab>('ports');

  const tabs: { id: Tab; label: string; icon: typeof MdAnchor }[] = [
    { id: 'ports', label: 'Ports', icon: MdAnchor },
    { id: 'terminals', label: 'Terminals', icon: MdDirectionsBoat },
    { id: 'agents', label: 'Agents', icon: MdSupportAgent },
    { id: 'warehouses', label: 'Warehouses', icon: MdWarehouse },
    { id: 'rules', label: 'Rules', icon: MdRule },
    { id: 'charges', label: 'Charges', icon: MdAttachMoney },
  ];

  return (
    <div className="w-full flex flex-col gap-6">
      <PageHeader
        title="Global Port Management"
        subtitle="Import UN/LOCODE ports, manage terminals and berths, and configure local tariffs."
        subtitleVariant="description"
        subtitleAccent={false}
        breadcrumb={[
          { label: 'Admin' },
          { label: 'Global Port Management', current: true },
        ]}
        tabs={
          <div className={erpPageTabsClass}>
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`${erpPageTabClasses(isActive)} inline-flex items-center gap-2 whitespace-nowrap`}
                >
                  <Icon className="h-4 w-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        }
      />

      <div>
        {activeTab === 'ports' && <PortList />}
        {activeTab === 'terminals' && <TerminalList />}
        {activeTab === 'agents' && <AgentList />}
        {activeTab === 'warehouses' && <WarehouseList />}
        {activeTab === 'rules' && <RulesChargesUI section="rules" />}
        {activeTab === 'charges' && <RulesChargesUI section="charges" />}
      </div>
    </div>
  );
}
